import ColorButton from "components/common/ColorButton";
import useModalLoading from "libs/hooks/useModalLoading";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { canEditForm } from "redux/modules/authSlice";
import { setSmartFormBackStep } from "redux/modules/uiSlice";

export default function ButtonController({
  hideBack = false,
  hideSaveDraft = false,
  hideSubmit = false,
  isDisabledDraftButton = false,
  isDisabledNextButton = false,
  isExtend = false,
  hasSubmit = false,
  saveDraftButtonText = "Save Draft",
  nextButtonText = "Next",
  onClickSaveDraft = () => {},
  onClickNext = () => {},
  onClickBack = () => {},
  onClickSubmit = () => {},
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { showLoading, hideLoading } = useModalLoading();
  const canEdit = useSelector(canEditForm);
  // const { role } = useSelector((state) => state.auth);

  if (isExtend) {
    return (
      <div
        style={{
          marginTop: 34,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="outlined"
          color="error"
          type="button"
          onClick={() => {
            dispatch(setSmartFormBackStep());
            onClickBack();
          }}
        >
          Back
        </ColorButton>
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="outlined"
          color="primary"
          onClick={onClickSaveDraft}
        >
          Save Draft
        </ColorButton>

        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="contained"
          color="primary"
          type="submit"
          disabled={isDisabledNextButton}
          onClick={() => {
            window.scrollTo(0, 0);
            onClickNext();
          }}
        >
          {nextButtonText}
        </ColorButton>
      </div>
    );
  }

  return (
    <div
      style={{
        marginTop: 34,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {!hideBack && (
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="outlined"
          color="error"
          type="button"
          onClick={() => {
            dispatch(setSmartFormBackStep());
            onClickBack();
          }}
        >
          Back
        </ColorButton>
      )}

      {canEdit && hideSaveDraft !== true && (
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="outlined"
          color="primary"
          disabled={isDisabledDraftButton}
          onClick={onClickSaveDraft}
        >
          {saveDraftButtonText}
        </ColorButton>
      )}

      {!hideSubmit && (
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="contained"
          color="primary"
          type="submit"
          disabled={isDisabledNextButton}
          onClick={() => {
            window.scrollTo(0, 0);
            onClickNext();
          }}
        >
          {nextButtonText}
        </ColorButton>
      )}
      {hasSubmit && (
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="contained"
          color="primary"
          type="submit"
          disabled={isDisabledNextButton}
          onClick={() => {
            window.scrollTo(0, 0);
            onClickSubmit();
          }}
        >
          Submit
        </ColorButton>
      )}
    </div>
  );
}
